











import { Component, Vue } from "vue-property-decorator";
@Component({})
export default class HoverBox extends Vue {
    isFirstHoverIn = true;

    async hoverIn(event: any) {
        if (this.$listeners["hoverIn"]) {
            this.$emit("hoverIn", event);
        } else {
            console.error(
                `[HoverBox warn] Invalid handler for event "hoverIn": got undefined`
            );
        }
    }
    async hoverOut(event: any) {
        if (this.$listeners["hoverOut"]) {
            this.$emit("hoverOut", event);
        } else {
            console.error(
                `[HoverBox warn] Invalid handler for event "hoverOut": got undefined`
            );
        }
    }
    async handleClick(event:any) {
        this.$emit("click",event);
        // if (this.$listeners["click"]) {
        //     this.$emit("click",event);
        // } else {
        //     console.error(
        //         `[HoverBox warn] Invalid handler for event "click": got undefined`
        //     );
        // }
    }

    mouseover(event: any) {
        if (
            this.$utils.isParents(event.toElement, event.currentTarget) == true
        ) {
            if (this.isFirstHoverIn == true) {
                this.hoverIn(event).then((res: any) => {
                    this.isFirstHoverIn = false;
                });
            }
        } 
        else if (
            this.$utils.isParents(event.toElement, event.currentTarget) == false
        ) {
            console.log("");
            
        }
    }
    mouseout(event: any) {
        if (
            this.$utils.isParents(event.toElement, event.currentTarget) == true
        ) {
            console.log("");
        } else if (
            this.$utils.isParents(event.toElement, event.currentTarget) == false
        ) {
            this.hoverOut(event).then((res: any) => {
                this.isFirstHoverIn = true;
            });
        }
    }
}
